import React, { useState, useEffect, useRef } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
//import { Link } from 'react-router-dom';  // para los submenu
//import "../lib/debug-monitor.js";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isThemeOpen, setIsThemeOpen] = useState(false);
  const themeRef = useRef(null);

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "/js/debug-monitor.js"; // 👈 SIN public
  //   script.async = true;

  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (themeRef.current && !themeRef.current.contains(event.target)) {
        setIsThemeOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const navItems = [
    { id: 'sobre-mi', label: 'Sobre Mí' },
    { id: 'formacion', label: 'Formación' },
    { id: 'servicios', label: 'Servicios' },
    { id: 'blog', label: 'Blog' },
    { id: 'tesoro', label: 'Proyectos' },
    { id: 'contacto', label: 'Contacto' }

  ];




  // const [isScrolled, setIsScrolled] = useState(false);
  // const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // 👇 VA ACA
  //useEffect(() => {
  //const debugMonitorScript = document.createElement("script");
  //debugMonitorScript.src = "/src/lib/debug-monitor.js";
  //debugMonitorScript.async = true;

  //document.body.appendChild(debugMonitorScript);

  //return () => {
  //document.body.removeChild(debugMonitorScript);
  //};
  //}, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const changeTheme = (theme) => {
    document.documentElement.classList.remove("dark", "light");
    document.documentElement.classList.add(theme);
  };
  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/90 backdrop-blur-md shadow-lg shadow-green-500/10' : 'bg-transparent'
        }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-2xl font-bold font-mono tracking-wider hover:scale-105 transition-transform"
            style={{ color: '#00FF41' }}
          >
            &lt;ORELLANA /&gt;
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-300 hover:text-green-400 transition-colors font-mono text-sm tracking-wide relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-green-400 transition-all group-hover:w-full"></span>
              </button>
            ))}
            <div className="relative" ref={themeRef}>
              {/* <button
                onClick={() => setIsThemeOpen(!isThemeOpen)}
                className="text-gray-300 hover:text-green-400 transition-colors font-mono text-sm tracking-wide"
              >
                Tema
              </button> */}

              {isThemeOpen && (
                <div className="absolute right-0 mt-2 w-40 bg-black border border-green-500 rounded shadow-lg">
                  <button
                    className="block w-full text-left px-4 py-2 hover:bg-green-500/10"
                    onClick={() => {
                      changeTheme("dark");
                      setIsThemeOpen(false);
                    }}
                  >
                    1
                  </button>
                  <button
                    className="block w-full text-left px-4 py-2 hover:bg-green-500/10"
                    onClick={() => {
                      changeTheme("light");
                      setIsThemeOpen(false);
                    }}

                  >
                    2
                  </button>
                </div>
              )}
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden text-green-400"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X /> : <Menu />}
          </Button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4">
            <nav className="flex flex-col gap-4">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-300 hover:text-green-400 transition-colors font-mono text-sm tracking-wide text-left py-2 px-4 hover:bg-green-500/10 rounded"
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );

}

export default Header;